class ErrorHandler {
  constructor() {
    //bind events
    pubsub.on('error', data => this.processError(data));
    pubsub.on('success', data => this.processSuccess(data));
    pubsub.on('info', data => this.processInfo(data));
  }
  processError(data) {
    data.title = data.errorTitle ? data.errorTitle : '';
    data.html = data.errorMsg ? data.errorMsg : '';
    this.showSwal('error', data);
  }
  processSuccess(data) {
    data.title = data.successTitle ? data.successTitle : '';
    data.html = data.successMsg ? data.successMsg : '';
    this.showSwal('success', data);
  }
  processInfo(data) {
    data.title = data.infoTitle ? data.infoTitle : '';
    data.html = data.infoMsg ? data.infoMsg : '';
    this.showSwal('info', data);
  }
  showSwal(type = 'success', options = {}) {
    const settings = {};
    Object.assign(settings, {
      title: '',
      html: '',
      width: undefined,
      toast: false,
      position: 'bottom-end',
      timer: 3500
    }, options);
    let swal = Swal;
    if (settings.toast) {
      swal = Swal.mixin({
        position: settings.position,
        showConfirmButton: false,
        timer: settings.timer
      });
    }
    swal.fire({
      icon: type,
      toast: settings.toast,
      title: settings.title,
      html: settings.html,
      width: settings.width,
      reverseButtons: true,
      heightAuto: false
    });
  }
}
window.errorHandler = new ErrorHandler();